import { useTranslation } from "react-i18next";
import { useEffect, useMemo } from "react";
import { Header } from "datastake-daf/dist/components";
import { useNavigate, useParams } from "react-router-dom";
import SubjectsWidget from "./components/SubjectsWidget";
import { renderBreadCrumbs } from "../../../helpers/breadCrumbs";
import DataSettingsWidget from "../components/DataSettingsWidget";
import DataChainOfCustoryWidget from "../components/DataChainOfCustodyWidget";
import DashboardLayout from "../../../components/dashboards/components/DashboardLayout";
import useInformationChannel from "../context";

export default function InformationChannel({ mod }) {
  const goTo = useNavigate();
  const { id } = useParams();
  const { t } = useTranslation();
  const { data, loading, fetchChannels } = useInformationChannel();

  useEffect(() => {
    fetchChannels(id, data.id !== id);
  }, [id])

  const breadCrumbs = useMemo(() => {
    const _breadCrumbs = renderBreadCrumbs({ t, view: 'information-channels', isDataStore: true, goTo, mod });

    return [
      ..._breadCrumbs,
      { label: id, onClick: () => { } },
    ];
  }, [t, goTo, mod, id]);

  return (
    <DashboardLayout>
      <Header
        breadcrumbs={breadCrumbs}
        title={data?.partner?.name}
      />

      <div className="content">
        <div className="view-content">
          <section>
            <DataSettingsWidget loading={loading} data={data.dataSettings} />
            <DataChainOfCustoryWidget loading={loading} data={data.dataChain} />
          </section>
          <section>
            <SubjectsWidget loading={loading} data={data.subjects} mod={mod} />
          </section>
        </div>
      </div>
    </DashboardLayout>
  );
}
